import type { Slot } from "@medplum/fhirtypes";
import { endOfDay, startOfDay } from "date-fns";
import type { RailAppointment, RailDeviceBand } from "./types";

/** Booked intervals of the session's required devices overlapping `date`, labelled
 *  by device. Restricted to devices this session uses (so the rail isn't cluttered
 *  with irrelevant resources) and to time not already shown as a care-manager
 *  appointment card (that booking already covers the device). */
export function deviceBandsForDay(
  date: Date,
  slots: Array<Slot & { scheduleDomainId?: string }>,
  metaByScheduleId: Map<string, { deviceId: string; name: string }>,
  requiredDeviceIds: Set<string>,
  appointments: RailAppointment[],
): RailDeviceBand[] {
  const dayStart = startOfDay(date);
  const dayEnd = endOfDay(date);
  const out: RailDeviceBand[] = [];
  for (const s of slots) {
    if (!s.start || !s.end) continue;
    const meta = s.scheduleDomainId ? metaByScheduleId.get(s.scheduleDomainId) : undefined;
    if (!meta || !requiredDeviceIds.has(meta.deviceId)) continue;
    const start = new Date(s.start);
    const end = new Date(s.end);
    if (!(start < dayEnd && end > dayStart)) continue;
    if (appointments.some((a) => start < a.end && end > a.start)) continue;
    out.push({ start, end, deviceName: meta.name });
  }
  return out;
}
